import React from "react";
import { Alert, AlertTitle, Link, Stack, IconButton } from "@mui/material";
import { FileDownload } from "@mui/icons-material"; // Download icon

interface ExcelSummaryBoxProps {
  sectionId: string | number;
  groupId: string | number;
  endorsementFormData: any; // You can replace with proper type if available
}

const ExcelSummaryBox: React.FC<ExcelSummaryBoxProps> = ({
  sectionId,
  groupId,
  endorsementFormData
}) => {
  console.log("endorsementFormData",endorsementFormData);
  console.log("sectionId",sectionId);
  console.log("groupId",groupId);
  const groupData =    endorsementFormData?.sumInsuredSectionData?.[sectionId]?.groups?.[groupId];

  if (!groupData) return null;

  return (
    <Stack spacing={2} style={{marginBottom:'5px',marginTop:'5px'}}>
      {/* ✅ Insert Summary */}
      {groupData?.excelPathForInsert && groupData?.excelInsertSummary && (
        <Alert severity="success" variant="filled" sx={{ borderRadius: 2 }}>
          <AlertTitle>Upload Successful</AlertTitle>
          {groupData.excelInsertSummary.count} rows inserted.{" "}
          <Link
            href={groupData.excelPathForInsert}
            target="_blank"
            rel="noopener noreferrer"
            underline="none"
          >
            <IconButton
              size="small"
              sx={{ color: "#1D6F42" }} // Excel green
            >
              <FileDownload />
            </IconButton>
          </Link>
        </Alert>
      )}

      {/* ❌ Delete Summary */}
      {groupData?.excelPathForDelete && groupData?.excelDeleteSummary && (
        <Alert severity="error" variant="filled" sx={{ borderRadius: 2 }}>
          <AlertTitle>Deletion Completed</AlertTitle>
          {groupData.excelDeleteSummary.count} rows deleted.{" "}
          <Link
            href={groupData.excelPathForDelete}
            target="_blank"
            rel="noopener noreferrer"
            underline="none"
          >
            <IconButton
              size="small"
              sx={{ color: "#1D6F42" }}
            >
              <FileDownload />
            </IconButton>
          </Link>
        </Alert>
      )}
    </Stack>
  );
};

export default ExcelSummaryBox;
